import { Button, Divider, IconButton, Modal, TextField, Typography } from "@mui/material";
import { alpha, Box } from "@mui/system";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
import CustomizedSteppers from "../customStepper";
import React, { useState } from "react";
import SuggestionAnswerComponent from "../suggestionAnswerComponent";
import SuggestionAvaliacaoComponent from "../suggestionAvaliacaoComponent";

export default function SuggestionModalAnswerComponent(params) {
  const {
    open,
    handleClose,
    newForm,
    setNewForm,
    error,
    setError,
    createForm,
    handleAddQuestion,
    handleRemoveQuestion,
    containerRef,
    lastItemRef,
    handleQuestionChange,
    stepsName = ["Novo formulário", "Pré-visualização"],
    setSnackbar = () => {},
    setStep = () => {},
    step = 0,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const validationForm = () => {
    if (!newForm?.title?.trim()) {
      setError(true);
      setSnackbar({
        children: "Por favor, preencha o título.",
        severity: "warning",
      });
      return;
    }
    if (newForm?.questions.some((q) => !q?.question?.trim())) {
      setError(true);
      setSnackbar({
        children: "Não é permitido perguntas em branco.",
        severity: "warning",
      });
      return;
    }
    if (newForm?.questions.some((q) => q?.type === 2 && !q?.options?.length)) {
      setError(true);
      setSnackbar({
        children: "Necessário adicionar opções para perguntas de seleção.",
        severity: "warning",
      });
      return;
    }
    setStep(step + 1);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Box sx={styles.boxModal}>
        <CustomizedSteppers stepNumber={step} steps={stepsName} />
        {step === 0 && (
          <Box>
            <Box sx={styles.boxTitle}>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                variant="filled"
                autoComplete="off"
                value={newForm?.title || ""}
                label={"Título do formulário"}
                error={!newForm?.title?.trim() && error}
                helperText={
                  !newForm?.title?.trim() && error ? "Título é obrigatório" : ""
                }
                onChange={(event) =>
                  setNewForm((prev) => ({ ...prev, title: event.target.value }))
                }
              />
            </Box>

            <Box sx={styles.boxMainPerguntas}>
              <Box sx={styles.boxPerguntas} ref={containerRef}>
                {newForm?.questions?.map((question, index) => (
                  <Box
                    key={question?.id}
                    ref={
                      index === newForm?.questions?.length - 1
                        ? lastItemRef
                        : null
                    }
                    sx={styles.boxAnswer}
                  >
                    <SuggestionAnswerComponent
                      id={question?.id}
                      question={question?.question}
                      type={question?.type}
                      options={question?.options}
                      onChange={handleQuestionChange}
                      index={index}
                      remove={handleRemoveQuestion}
                      add={handleAddQuestion}
                    />
                    <Box sx={styles.containerButtonIcons}>
                      {newForm?.questions?.length > 1 && (
                        <>
                          <IconButton
                            onClick={() => handleRemoveQuestion(question.id)}
                          >
                            <DeleteOutlineOutlined color="error" />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  </Box>
                ))}
                <Box sx={styles.containerButtonNewPergunta}>
                  <Button onClick={handleAddQuestion} variant="contained">
                    Nova pergunta
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {step === 1 && (
          <Box sx={styles.conatinerPreVisualizacao}>
            <SuggestionAvaliacaoComponent form={newForm} />
          </Box>
        )}

        <Box sx={styles.containerButton}>
          {step !== 0 && (
            <Box sx={{ width: "100%" }}>
              {" "}
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setStep(step - 1)}
              >
                Voltar
              </Button>
            </Box>
          )}

          <Button
            variant="outlined"
            color="error"
            onClick={() => handleClose()}
          >
            Cancelar
          </Button>

          {step === 0 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => validationForm()}
            >
              Avançar
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => createForm()}
            >
              Salvar
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
